// components/Loader.js
import React from 'react';

function Loader() {
  return (
    <div className="loader-overlay">
      <div className="spinner"></div> {/* Customize your spinner here */}
    </div>
  );
}

export default Loader;
